"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EduClassUrlList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var lifeHome_1 = require("../../model/lifeHome");
var service_1 = require("../../../library/base/service");
var EduClassUrlList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(EduClassUrlList, _super);
    function EduClassUrlList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '教育视频图片列表';
        _this.code = '101094';
        _this.desc = '教育视频图片列表';
        _this.requestParams = new lifeHome_1.EduClassUrlListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return EduClassUrlList;
}(service_1.BaseService));
exports.EduClassUrlList = EduClassUrlList;
//# sourceMappingURL=eduClassUrlList.js.map